export * from './styles/icons-24/prizm-icons';
export * from './lib/prizm-icons.module';
export * from './lib/prizm-icons.registry';
export * from './lib/prizm-icons.component';
export * from './lib/svg/my-icons';
